import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface SendMessageRequest {
  receiverId: number;
  message: string;
}

export interface ChatMessageResponse {
  id: number;
  senderId: number;
  senderName: string;
  senderProfileImageUrl?: string;
  receiverId: number;
  receiverName: string;
  receiverProfileImageUrl?: string;
  message: string;
  sentAt: string;
  isRead: boolean;
  readAt?: string;
  isFromCurrentUser: boolean;
}

export interface ChatConversationResponse {
  otherUserId: number;
  otherUserName: string;
  otherUserProfileImageUrl?: string;
  lastMessage: string;
  lastMessageAt?: string;
  isLastMessageRead: boolean;
  unreadCount: number;
  messages: ChatMessageResponse[];
}

export interface MarkMessagesAsReadRequest {
  otherUserId: number;
}

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private apiUrl = `${environment.apiUrl}/api/chat`;

  constructor(private http: HttpClient) {}

  sendMessage(request: SendMessageRequest): Observable<any> {
    return this.http.post(`${this.apiUrl}/send`, request);
  }

  getConversation(otherUserId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/conversation/${otherUserId}`);
  }

  getConversations(): Observable<any> {
    return this.http.get(`${this.apiUrl}/conversations`);
  }

  markMessagesAsRead(request: MarkMessagesAsReadRequest): Observable<any> {
    return this.http.post(`${this.apiUrl}/mark-read`, request);
  }

  /**
   * Check for new messages (for real-time updates)
   */
  checkForNewMessages(): Observable<any> {
    return this.http.get(`${this.apiUrl}/check-new-messages`);
  }
}
